import { useState } from 'react';
import { ChangePassword } from './ChangePassword';
import { ChangePasswordSuccess } from './ChangePasswordSuccess';
import { axiosInstance } from '../../../utils/axiosInstance';
import { AxiosRequestConfig } from 'axios';
import { showToast } from '../../../components/atoms/Toast/Toast';

export const ForgotPassword = () => {
  const [step, setStep] = useState(0);
  const [emailToSend, setEmailToSend] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const sendPasswordResetEmail = async (email) => {
    setIsLoading(true);
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    const requestOptions: AxiosRequestConfig = {
      headers,
      url: `${process.env.NEXT_PUBLIC_API_PRO}/login/forgot_password`,
      method: 'POST',
      data: { email },
    };

    try {
      await axiosInstance(requestOptions);
      setIsLoading(false);
    } catch (error) {
      showToast({
        type: 'error',
        message: 'Erro inesperado. Tente novamente.',
      });
      setIsLoading(false);
    }
  };

  const handleSendEmail = async (email) => {
    setEmailToSend(email);
    await sendPasswordResetEmail(email);
    setStep(1);
  };

  const handleResendEmail = async () => {
    await sendPasswordResetEmail(emailToSend);
  };

  return (
    <>
      {step === 0 && (
        <ChangePassword
          onButtonClick={handleSendEmail}
          isButtonLoading={isLoading}
        />
      )}
      {step === 1 && (
        <ChangePasswordSuccess onButtonClick={handleResendEmail} />
      )}
    </>
  );
};
